import { commonMetaData } from "~/store/_helpers/common-helper"

/** GrpcAccessorの基底クラス */
class GrpcAccessorBase {
  private readonly rootState;

  constructor(rootState) {
    this.rootState = rootState
  }

  /** gRPCリクエスト時に渡すヘッダ情報を取得 */
  getMetadata(): ReturnType<typeof commonMetaData> {
    return commonMetaData(this.rootState)
  }
}
export default GrpcAccessorBase
